const hasSpecialCharacters = (value = '') => /[^A-Za-z0-9 ]/.test(value)

const encodeUtf8ToHex = (value = '') => {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(value)
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
}

const encodeFieldForTransport = (payload, fieldName, transportFieldName, hexFieldName) => {
  const value = payload?.[fieldName]
  if (typeof value !== 'string') {
    return
  }

  if (hasSpecialCharacters(value)) {
    const hexValue = encodeUtf8ToHex(value)
    payload[fieldName] = hexValue
    payload[transportFieldName] = 'hex'
    payload[hexFieldName] = hexValue
  }
}

export const encodeIMLogTextFields = (imLog) => {
  if (!imLog) return imLog

  const payload = { ...imLog }
  encodeFieldForTransport(payload, 'title', 'titleTransport', 'titleHex')
  encodeFieldForTransport(payload, 'description', 'descriptionTransport', 'descriptionHex')

  return payload
}
